import React from "react";
import type { Player } from "video.js";

export interface MediaContextType {
  playbackRef: Player | null;
  setPlaybackRef: (value: Player | null) => void;
  videoRef: HTMLVideoElement | null;
  setVideoRef: (value: HTMLVideoElement | null) => void;
}

const MediaContext = React.createContext<MediaContextType>({
  playbackRef: null,
  setPlaybackRef: () => {
    throw new Error("override this");
  },
  videoRef: null,
  setVideoRef: () => {
    throw new Error("override this");
  },
});

export default MediaContext;
